export default __webpack_public_path__ + "static/media/Criteria_Icon.b57c73b5.svg";